import { getId } from 'services/utils'
import { WithId } from 'types/common'
import { CountryInfo, COUNTRY_IT, COUNTRY_SV } from './countries'

export type GeoAreaPrefix = 'mi' | 'sk'

export type Geoarea = WithId & {
  name: string
  country: CountryInfo
  prefix: GeoAreaPrefix
}

export const GEOAREA_MI: Geoarea = {
  id: 1,
  name: 'Milano',
  prefix: 'mi',
  country: COUNTRY_IT,
}

export const GEOAREA_SK: Geoarea = {
  id: 2,
  name: 'Stockolm',
  prefix: 'sk',
  country: COUNTRY_SV,
}

export const DEFAULT_GEOAREA = GEOAREA_MI
export const DEFAULT_GEOAREA_ID = DEFAULT_GEOAREA.id

export const SUPPORTED_GEOAREAS: Geoarea[] = [GEOAREA_MI, GEOAREA_SK]
export const SUPPORTED_GEOAREAS_IDS = SUPPORTED_GEOAREAS.map(getId)
